import React from 'react';
import { useTranslation } from 'utils/i18n';

/**
 * Generic placeholder page. Uses shared `app.comingSoonTitle` / `app.comingSoonMessage`
 * when title/message props are omitted so the language dropdown applies.
 */
const ComingSoon = ({ title: titleProp, message: messageProp }) => {
  const { t } = useTranslation();
  const title = titleProp ?? t('app.comingSoonTitle');
  const message = messageProp ?? t('app.comingSoonMessage');
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        minHeight: '60vh',
        textAlign: 'center',
        color: 'var(--color-text-primary)'
      }}
    >
      <div style={{ maxWidth: 520 }}>
        <h2 style={{ marginBottom: 12 }}>{title}</h2>
        <p style={{ color: 'var(--color-text-secondary)' }}>{message}</p>
      </div>
    </div>
  );
};

export default ComingSoon;
